import React, { type ComponentPropsWithRef, forwardRef } from 'react';
import { cn } from '@/utils';
interface Props {
  children?: React.ReactNode;
  props?: ComponentPropsWithRef<'header'>;
  className?: string;
  variant?: 'default' | 'compact';
}
export const HeaderContainer = forwardRef<HTMLElement, Props>(({
  children,
  className,
  props,
  variant = 'default'
}, ref) => {
  return <header ref={ref} className={cn('z-40 flex sticky top-0 w-full bg-[#FFF]', variant === 'compact' ? 'min-h-[54px] px-md pb-[12px] pt-[16px] tablet-sm:px-[24px] tablet-lg:px-[40px]' : 'min-h-[60px] px-md py-sm tablet-sm:px-[24px] tablet-lg:px-[40px]', 'm-auto flex items-center justify-between', className)} {...props}>
        {children}
      </header>;
});
HeaderContainer.displayName = 'HeaderContainer';